import axiosClient from "../axiosClient";

export const company = {
    get: (data) => {
        return axiosClient.get('/company/get-list-company/', {
            params: data
        })
    }, 
    post: (data) => {
        return axiosClient.post('/company/post-add-company/', data)
    },
    put: (param, data) => {
        return axiosClient.put(`/company/put-change-info-company/?company_code=${param}`, data)
    },
    delete: (data) => {
        return axiosClient.delete('/company/delete-remove-company/', {
            params: data
        })
    }
}